import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '@/store';
import { PaginationState, SortingState } from '@tanstack/react-table';

interface ProjectsListState {
  projectsListPagination: PaginationState;
  projectsListSorting: SortingState;
}

const initialState: ProjectsListState = {
  projectsListPagination: {
    pageIndex: 0,
    pageSize: 50,
  },
  projectsListSorting: [
    {
      id: 'lastModifiedDatetime',
      desc: true,
    },
  ],
};

const projectsListSlice = createSlice({
  name: 'projects',
  initialState: initialState,
  reducers: {
    setProjectsPagination: (state, action: PayloadAction<PaginationState>) => {
      state.projectsListPagination = action.payload;
    },
    setProjectsSorting: (state, action: PayloadAction<SortingState>) => {
      state.projectsListSorting = action.payload;
    },
  },
});

export const { setProjectsPagination, setProjectsSorting } = projectsListSlice.actions;

export const selectProjectsPagination = (state: RootState) => {
  return state.projects.projectsListPagination;
};
export const selectProjectsSorting = (state: RootState) => {
  return state.projects.projectsListSorting;
};

export const projectsListReducer = projectsListSlice.reducer;
